module.exports = __webpack_public_path__ + "static/media/LB-black.4b1647e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/assets/LB-black.svg
// module id = 242
// module chunks = 241 242 243